import { ElMessage } from 'element-plus';

const getHost = () => {
  const requestEvent = useRequestEvent();
  if (requestEvent) {
    return requestEvent.node.req.headers.host;
  }

  return window.location.host;
};

const isTokenExpired = (token) => {
  try {
    const payload = token.split('.')[1];

    let decodedPayload;
    if (typeof Buffer !== 'undefined') {
      decodedPayload = Buffer.from(payload, 'base64').toString();
    } else {
      decodedPayload = window.atob(payload);
    }

    const { exp } = JSON.parse(decodedPayload);

    return Date.now() >= exp * 1000;
  } catch (err) {
    console.error('Invalid token:', err);
    return true;
  }
};

const getBaseURL = () => {
  const host = getHost();
  const hostname = host?.replace(/:\d+$/, '')?.toLowerCase();
  if (hostname === 'tichalinka.dev' || hostname?.endsWith('.tichalinka.dev')) {
    return 'https://api-dev.tichalinka.cz';
  }

  if (useRuntimeConfig().public.apiUrl) {
    return useRuntimeConfig().public.apiUrl?.startsWith('http') ? useRuntimeConfig().public.apiUrl : `https://${useRuntimeConfig().public.apiUrl}`;
  }

  return `${useRequestURL().protocol}//${host.replace(useRuntimeConfig().public.port, useRuntimeConfig().public.apiPort)}`;
};

const request = (method) => {
  return async(url, options) => {
    let token = window.localStorage.getItem('token') || useAuthStore().token;
    const refresh = window.localStorage.getItem('refresh') || useAuthStore().refresh;

    const baseURL = getBaseURL();

    if (token && refresh && isTokenExpired(token)) {
      const refreshResponse = await $fetch('/auth/token/refresh', {
        baseURL,
        method: 'POST',
        body: {
          refresh,
          // Sent so a blocked device is stopped here too, not only a blocked
          // address — otherwise the session renews itself for days.
          device_id: useDeviceId().getDeviceId(),
        },
      }).catch((error) => {
        // A refusal here is the block, not an expired session. Swallowing it sends
        // the original request on with a dead token, and the 401 below logs the
        // caller out with a generic error instead of the wording for the block.
        if (blockedMessage(error)) throw error;

        return false;
      });

      if (refreshResponse) {
        useAuthStore().setAuth(refreshResponse);
        token = useAuthStore().token;
      }
    }

    const requestOptions = {
      method,
      baseURL,
      ...options,
      headers: {
        ...(token ? { Authorization: token } : {}),
        ...(options?.headers || {}),
      },

      onResponseError({ response }) {
        if (response?.status === 401) {
          // useLogout();
          useAuthStore().logout();
        }

        if (response.status === 429) {
          ElMessage.error({
            message: 'Byl překročen limit, chvíli počkejte a zkuste to znovu.',
            showClose: true,
          });
        }
      },
    };

    return $fetch(url, requestOptions);
  };
};

export default {
  delete: request('DELETE'),
  get: request('GET'),
  patch: request('PATCH'),
  post: request('POST'),
  put: request('PUT'),
  getBaseURL,
};
